import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create({
  container: {
    justifyContent: "center",
    alignItems: "center",
    _web: {
      containerType: "size",
    },
  },
});

export default stylesheet;
